<div class="rd-widget widgetNoTopBorder" *ngIf="widgetData">
  <div class="table-part">
    <table class="widget-flex" style="height: 100%;" aria-hidden="true">
      <thead>
        <tr class="widget-ruller-flex">
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
          <th scope="col" class="widget-grid-column">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr class="light-grey-line">
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'reportValuationLeaseholdNameOfFreeholder'" [align]="'left'" [bold]="true"></widget-label></td>
          <td colspan="10"><widget-value [align]="'right'" [bold]="true">{{widgetData.reportValuationLeaseholdNameOfFreeholder}}</widget-value></td>
        </tr>
        <tr class="white-line">
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'reportValuationLeaseholdDurationLeft'" [align]="'left'" [bold]="true"></widget-label></td>
          <td colspan="10"><widget-value [align]="'right'" [bold]="true">{{widgetData.reportValuationLeaseholdDurationLeft | rdLocalizedNumber:0}} {{'leasehold.labelYears' | rdTranslate}}</widget-value>
        </tr>
        <tr class="light-grey-line">
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'reportValuationLeaseholdAnnualPayment'" [align]="'left'" [bold]="true"></widget-label></td>
          <td colspan="10"> <widget-value [align]="'right'" [bold]="true">{{currency}} {{widgetData.reportValuationLeaseholdAnnualPayment | rdLocalizedNumber:0}}</widget-value></td>
        </tr>
        <tr class="white-line">
          <td colspan="6"><widget-label [widget]="this" [fieldName]="'reportValuationLeaseholdIndexation'" [align]="'left'" [bold]="true"></widget-label></td>
          <td colspan="10"> <widget-value [align]="'right'" [bold]="true">{{(widgetData.reportValuationLeaseholdIndexation * 100 || 0)  | rdLocalizedNumber:1}} %</widget-value></td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
